/*
 * @Author: Christion.Young
 * @Date: 2021-01-12 18:13:54
 * @LastEditors: Christion.Young
 * @LastEditTime: 2021-07-23 10:30:52
 * @Description: store
 */
import Vue from "vue";
import Vuex from "vuex";
import user from "./modules/user";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {
    // 全局地域筛选开关
    setRegionFilterEnabled(state, value) {
      // 兼容直接挂载到 user 模块
      if (this.state.user) {
        this.state.user.regionFilterEnabled = value;
      } else {
        state.regionFilterEnabled = value;
      }
    },
  },
  actions: {},
  modules: {
    user,
  },
});
